import type { Story } from '@/store/story-types'

export const LIVE_COMMERCE_STORY: Story = {
  id: 'live-commerce',
  name: 'LIVE — Shop the Stream',
  narrative: 'An influencer live commerce platform with real-time streaming, flash deals, product spotlights, live chat interaction, and instant purchase during broadcasts.',
  goals: ['Join live stream', 'Browse flash deals', 'Chat with host', 'Purchase during stream'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'home',
      description: 'Live stream page with video player, flash deal carousel, and product spotlight',
      blockRef: { category: 'k-commerce', blockId: 'live-stream' },
    },
    {
      id: 'pg-chat', title: 'Live Chat', order: 1, status: 'draft', elementCount: 4, linkedPageId: 'chat',
      description: 'Live chat room with real-time messages and deal countdown timer',
      blockRef: { category: 'k-commerce', blockId: 'live-chat' },
    },
    {
      id: 'pg-cart', title: 'Cart', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Cart and checkout for products purchased during the live stream',
      blockRef: { category: 'k-commerce', blockId: 'cart-checkout' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Join Live Stream',
      description: 'Visitor joins an active live commerce stream',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the live stream player, flash deal carousel, and product spotlight are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Browse Flash Deals',
      description: 'Visitor browses time-limited flash deals during the stream',
      steps: [
        { type: 'given', text: 'the visitor is watching the live stream', linkedPageId: 'home' },
        { type: 'when', text: 'a flash deal appears in the carousel' },
        { type: 'then', text: 'the deal shows product image, discounted price, and remaining time' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Chat with Host',
      description: 'Visitor interacts with the host via live chat',
      steps: [
        { type: 'given', text: 'the visitor navigates to the live chat page', linkedPageId: 'chat' },
        { type: 'when', text: 'they send a message' },
        { type: 'then', text: 'the message appears in the real-time chat feed alongside a deal countdown timer' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Purchase During Stream',
      description: 'Visitor purchases a spotlighted product during the live stream',
      steps: [
        { type: 'given', text: 'the visitor sees a product spotlight on the stream', linkedPageId: 'home' },
        { type: 'when', text: 'they tap the Buy Now button on the spotlight' },
        { type: 'then', text: 'the item is added to the cart with the flash deal price', linkedPageId: 'cart' },
        { type: 'and', text: 'checkout completes the purchase before the deal expires', linkedFlowId: 'flashDealCheckout' },
      ],
    },
  ],
}
